import React from 'react';
import { axiosAuth } from './apiBase';

import { handleResponse, handleError } from './response';

const useGLSalarySlabsService = () => {
    const getGLSalarySlab = async () => {
        try {
            const response = await axiosAuth.get(`/api/GLSalarySlabs`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };
    const getGLSalarySlabById = async (id) => {
        try {
            const response = await axiosAuth.get(`/api/GLSalarySlabs/${id}`);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    const updateGLSalarySlab = async (id, values) => {
        try {
            const response = await axiosAuth.put(`/api/GLSalarySlabs?Id=${id}`, values);
            return handleResponse(response);
        } catch (error) {
            return handleError(error);
        }
    };

    return { getGLSalarySlab, getGLSalarySlabById, updateGLSalarySlab };
};

export default useGLSalarySlabsService;
